// js/common/common-links.js

import { gsap } from "gsap";

export function initCommonLinks() {
  const links = document.querySelectorAll(".p-common-links__link");

  if (links.length === 0) return;

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  links.forEach((link) => {
    const lines = link.querySelectorAll(".p-common-links__line");

    if (lines.length === 0) return;

    if (reduceMotion) {
      gsap.set(lines, {
        scaleX: 1,
      });
      return;
    }

    const state = {
      isHover: false,
    };

    lines.forEach((line) => {
      const delay = getInitialDelay(line);
      animateLine(line, state, delay);
    });

    link.addEventListener("mouseenter", () => {
      state.isHover = true;
      restartLines(lines, state);
    });

    link.addEventListener("mouseleave", () => {
      state.isHover = false;
      restartLines(lines, state);
    });
  });
}

function restartLines(lines, state) {
  lines.forEach((line) => {
    gsap.killTweensOf(line);
    animateLine(line, state);
  });
}

function animateLine(line, state, delay = 0) {
  const config = getLineConfig(line, state.isHover);

  gsap.to(line, {
    scaleX: gsap.utils.random(config.scaleMin, config.scaleMax),
    duration: gsap.utils.random(config.durationMin, config.durationMax),
    delay,
    ease: "power1.inOut",
    overwrite: true,

    onComplete() {
      animateLine(line, state);
    },
  });
}

function getInitialDelay(line) {
  if (line.classList.contains("p-common-links__line--top")) {
    return 0;
  }

  if (line.classList.contains("p-common-links__line--center")) {
    return 0.2;
  }

  return 0.4;
}

function getLineConfig(line, isHover) {
  let durationMin;
  let durationMax;
  let scaleMin;
  let scaleMax;

  if (line.classList.contains("p-common-links__line--top")) {
    durationMin = 0.64;
    durationMax = 1.28;
    scaleMin = 0.75;
    scaleMax = 1;
  } else if (line.classList.contains("p-common-links__line--center")) {
    durationMin = 0.4;
    durationMax = 0.8;
    scaleMin = 0.65;
    scaleMax = 1;
  } else {
    durationMin = 0.2;
    durationMax = 0.48;
    scaleMin = 0.45;
    scaleMax = 1;
  }

  if (isHover) {
    durationMin *= 0.2;
    durationMax *= 0.2;
    scaleMin = 1.3;
    scaleMax = 1.5;
  }

  return {
    durationMin,
    durationMax,
    scaleMin,
    scaleMax,
  };
}